<template>
<div>
	<b-modal id="modalSuccess" hide-footer hide-header no-close-on-backdrop no-close-on-esc @close="close" size="lg">
		<div class="fullscreen" v-if="show">

			<div class="head head-success xl">
				<div class="container text-center">
					<i class="icon mt-4 icon-xl invert icon-check"></i>
					<h1 class="mt-4">Control realizado con éxito</h1>
				</div>
			</div>
			
			<div class="content bg-grey">
				<div class="container">
					<div class="p-4 mt-4">


						<div v-if="control.type=='ADMISSION' || control.type=='DAMAGES'">			
							<div v-if="control.damages.length>0">
								
								<h6 class="mt-3">Daños</h6>
								<div class="damage-list">
									<div class="damage"  v-for="damage in control.damages" :key="damage.id">
										<div class="map-content">
											<div class="map" :style="{backgroundImage: `url('${ require('@/assets/img/carsDraws/'+control.car.category.draw+'/'+damage.side+'.png') }')` }" >
												<div >
													<div class="point animated bounceIn"
														:style="`left:${damage.position.left}%; top:${damage.position.top}%`" 
														:class="[damage.type.toLowerCase()]"						
													>
													</div>
												</div>
											</div>
										</div>
										<div class="detail">
											<strong><small>{{damage.typeText}}</small></strong><br>
											{{damage.description}}
										</div>
										<div class="images images-sm">
											<div class="image" v-for="image in damage.images" :key="image.id">
												<div class="background" :style="'background-image:url('+API_URL+image.urlThumb+')'"></div>
											</div>
										</div>
										
									</div>
								</div>
							</div>
							<div v-else>
								<p>Vehículo ingresado sin daños ni faltantes</p>
							</div>
							
							<div v-if="control.missings.length>0">
								<h6 class="mt-3 mb-2">Faltantes</h6>
								<p class="ml-2" v-for="missing in control.missings" :key="missing.id">
									<strong>-</strong> {{missing.description}}
								</p>
							</div>

							<div v-if="control.truck_mat">
								<h6 class="mt-3">Conductor responsable</h6>
								<table class="table table-sm table-labeled-30">
									<tr>
										<td><strong>Matrícula</strong></td>
										<td>{{control.truck_mat}}</td>
									</tr>
									<tr>
										<td><strong>Conductor</strong></td>
										<td>{{control.truck_driver_name}}</td>
									</tr>
									<tr>
										<td><strong>Firma</strong></td>
										<td v-if="control.truck_driver_signature"><img :src="control.truck_driver_signature" class="img-fluid"></td>
										<td v-else>No se ha podido registrar la firma</td>
									</tr>
								</table>
							</div>

							<div v-if="control.car.deposit">
								<h6 class="mt-3">El vehículo debe ser movido al depósito {{control.car.deposit.title}}</h6>
							</div>
							
						</div>
						

						<div v-if="control.type=='PRE_DELIVERY'">
							<table class="table table-sm table-labeled-30">
								<tr>
									<td><strong>Lubricantes</strong></td>
									<td>
										<p v-for="lubricant in control.lubricants" :key="lubricant.id">
											<strong>-</strong> {{lubricant.lubricant.title}} <strong class="ml-2"> {{lubricant.liters}}L</strong>
										</p>
									</td>
								</tr>
								<tr>
									<td><strong>Pulido</strong></td>
									<td>
										<span v-if="control.polished=='total'">Pulido total </span>
										<span v-if="control.polished=='partial'">Parcial - Se han pulido {{control.polished_pieces}} piezas</span>
										<span v-if="control.polished=='none'">No se han pulido piezas</span>
									</td>
								</tr>
								<tr>
									<td><strong>Carga de gas</strong></td>
									<td>
										<span v-if="control.gas_charge">Si</span>
										<span v-else>No</span>
									</td>
								</tr>
							</table>

							<div class="alert alert-sm mt-2 alert-warning" v-if="control.has_damages">Se han detectado daños</div>

						</div>

						<div v-if="control.type=='DELIVERY'">			
							<div v-if="control.damages.length>0">
								<h6 class="mt-3">Daños</h6>
								<div class="damage-list">
									<div class="damage"  v-for="damage in control.damages" :key="damage.id">
										<div class="map-content">
											<div class="map" :style="{backgroundImage: `url('${ require('@/assets/img/carsDraws/'+control.car.category.draw+'/'+damage.side+'.png') }')` }" >
												<div >
													<div class="point animated bounceIn"
														:style="`left:${damage.position.left}%; top:${damage.position.top}%`" 
														:class="[damage.type.toLowerCase()]"
														:ref="`damage_${damageIndex}`" 						
													>
													</div>
												</div>
											</div>
										</div>
										<div class="detail">
											<strong><small>{{damage.typeText}}</small></strong><br>
											{{damage.description}}
										</div>
										<div class="images images-sm">
											<div class="image" v-for="image in damage.images" :key="image.id">
												<div class="background" :style="'background-image:url('+API_URL+image.urlThumb+')'"></div>
											</div>
										</div>
										
									</div>
								</div>
							</div>
							<div v-else>
								<p>Vehículo entregado sin daños ni faltantes</p>
							</div>
							
							<div v-if="control.missings.length>0">
								<h6 class="mt-3 mb-2">Faltantes</h6>
								<p class="ml-2" v-for="missing in control.missings" :key="missing.id">
									<strong>-</strong> {{missing.description}}
								</p>
							</div>

							<div v-if="control.truck_mat">
								<h6 class="mt-3">Conductor responsable</h6>
								<table class="table table-sm table-labeled-30">
									<tr>
										<td><strong>Matrícula</strong></td>
										<td>{{control.truck_mat}}</td>
									</tr>
									<tr>
										<td><strong>Conductor</strong></td>
										<td>{{control.truck_driver_name}}</td>
									</tr>
									<tr>
										<td><strong>Firma</strong></td>
										<td v-if="control.truck_driver_signature"><img :src="control.truck_driver_signature" class="img-fluid"></td>
										<td v-else>No se ha podido registrar la firma</td>
									</tr>
								</table>
							</div>
							
						</div>

						<div v-if="control.files.length>0">
							<h6 class="mt-3">Adjuntos</h6>
							<div class="images">
								<div class="image" v-for="file in control.files" :key="file.id">
									<div class="background" :style="'background-image:url('+API_URL+file.urlThumb+')'"></div>
								</div>
							</div>
						</div>
						
						<div v-if="control.comments">
							<p>{{control.comments}}</p>
						</div>

					</div>
					
				</div>
			</div>
			<div class="footer">
				<div class="container">
					<div class="btn btn-block btn-primary" @click="close()">
						Cerrar
					</div>
				</div>
			</div>
		</div>
	</b-modal>
</div>
</template>
	

<script>
import { mapMutations } from 'vuex'

export default {
	name: 'ControlSuccess',
	props:['control'],
	data () {
		return {
			API_URL: process.env.VUE_APP_API_URL,
			loading: true,
			show: false,
		}
	},
	mounted(){
		this.open()
	},
	methods:{
		...mapMutations(['deleteControl']),
		open () {
			this.show = true
			this.$bvModal.show('modalSuccess')
		},
		close(){
			this.show = false
			this.$router.push(`/control/${this.control.car.id}`)
			this.deleteControl()
		}
	}
}


</script>

<style scoped lang="scss">
.damage-list{
	width: 100%;

	.damage{
		display: flex;
		width: 100%;

		.map-content{
			width:120px;
		}
		.detail{
			flex-grow: 1;
		}
		.images{
			.image{
				width: 48px;
				height:48px;
			}
		}
	}
}
</style>
